<!-- 服务 -->
<template>
  <div class="page">
    <!-- 横幅 -->
    <Banner></Banner>
    <!-- 什么是云企业 -->
    <WhatCloudEnterprise></WhatCloudEnterprise>
    <!-- 项目运营体系 -->
    <ProjectOperation></ProjectOperation>
    <!-- 为什么是云企业 -->
    <WhyCloudEnterprise></WhyCloudEnterprise>
    <!-- 痛点场景 -->
    <PainPointScenario></PainPointScenario>
    <!-- 行业矛盾 -->
    <Contradiction></Contradiction>
    <!-- 核心能力 -->
    <CoreCompetencies></CoreCompetencies>
    <!-- 解决难题 -->
    <SolveProblem></SolveProblem>
    <!-- 老板关心的问题 -->
    <ConcernProblem></ConcernProblem>
    <!-- 云企业认证 -->
    <CloudEnterpriseAuth></CloudEnterpriseAuth>
  </div>
</template>

<script>
import Banner from "./components/Banner.vue";
import WhatCloudEnterprise from "./components/WhatCloudEnterprise.vue";
import ProjectOperation from "./components/ProjectOperation.vue";
import WhyCloudEnterprise from "./components/WhyCloudEnterprise.vue";
import PainPointScenario from "./components/PainPointScenario.vue";
import Contradiction from "./components/Contradiction.vue";
import CoreCompetencies from "./components/CoreCompetencies.vue";
import SolveProblem from "./components/SolveProblem.vue";
import ConcernProblem from "./components/ConcernProblem.vue";
import CloudEnterpriseAuth from "./components/CloudEnterpriseAuth.vue";

export default {
  components: {
    Banner,
    WhatCloudEnterprise,
    ProjectOperation,
    WhyCloudEnterprise,
    PainPointScenario,
    Contradiction,
    CoreCompetencies,
    SolveProblem,
    ConcernProblem,
    CloudEnterpriseAuth
  }
};
</script>

<style lang="less" scoped>
:deep(.double-arrow) {
  height: 32px;
  background-image: url('@/assets/img/cooperation/double_arrow.png');
  background-repeat: no-repeat;
  background-size: 32px 32px;
  background-position: center;
}
</style>
